<template>
    <form-item-wrapper :widget="widget" :formData="formData" :isDesign="isDesign" ref="itemref">
        <a-select v-model:value="formData[widget.name]" :options="widget.options.optionItems" :mode="widget.options.mode"
            :fieldNames="fieldNames" :optionFilterProp="widget.options.optionFilterProp"
            :showSearch="widget.options.showSearch" :labelInValue="widget.options.labelInValue"
            :maxTagCount="widget.options.maxTagCount" :maxTagTextLength="widget.options.maxTagTextLength"
            :disabled="widget.options.disabled" :allowClear="widget.options.allowClear"
            :placeholder="widget.options.placeholder" :notFoundContent="widget.options.notFoundContent"
            @change="handleOnChange" @[eventName]="remoteQuey"></a-select>
    </form-item-wrapper>
</template>

<script setup>
import FormItemWrapper from "./form-item-wrapper.vue";
import { ref, toRefs, computed, onMounted, watch } from 'vue';
import useEvent from "./useEvent";
import http from "@/request/request";
import { message } from 'ant-design-vue';

const props = defineProps({
    widget: Object,
    formData: Object,
    isDesign: Boolean,
})
const { widget, formData, isDesign } = toRefs(props)
const itemref = ref(null)
const eventName = computed(() => !!widget.value.options.showSearch && !!widget.value.options.isRemote ? 'search' : null)
const fieldNames = computed(() => JSON.parse(widget.value.options.fieldNames))

const loadOptions = () => {
    const queryFunction = JSON.parse(widget.value.options.queryFunction)
    if (!isDesign.value && !!queryFunction.path) {
        const config = {
            url: queryFunction.path,
            method: queryFunction.method || "get",
            [queryFunction.method == 'post' ? 'data' : 'params']: queryFunction.params,
        }
        http.request(config).then(res => {
            if (res.data.code == 200) {
                widget.value.options.optionItems = res.data.rows;
                console.log("success");
            } else if (res.data.msg) {
                message.error(res.data.msg);
            }
        }).catch(err => message.error("请求失败," + err))
    }
}

const remoteQuey = (value) => {

}

onMounted(() => loadOptions())
watch(
    () => widget.value.options.queryFunction,
    (value, oldValue) => {
        loadOptions()
    }
)

const {
    handleOnChange,
} = useEvent(widget.value, itemref, formData.value);
</script>